module.exports = __webpack_public_path__ + "img/2.302b51b8.gif";